import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import clsx from 'clsx'
import useStyles from '../styles'

export default function FormSection({
  title,
  titleId,
  titleTestId,
  description,
  descriptionTestId,
  children,
}) {
  const classes = useStyles()

  return (
    <Box className={classes.fieldSection}>
      <Typography
        component="h3"
        className={clsx(
          classes.sectionTitle,
          description && classes.sectionTitleWithHelper,
        )}
        id={titleId}
        data-testid={titleTestId}
      >
        {title}
      </Typography>
      {description ? (
        <Typography
          className={classes.sectionHelper}
          data-testid={descriptionTestId}
        >
          {description}
        </Typography>
      ) : null}
      {children}
    </Box>
  )
}

FormSection.propTypes = {
  title: PropTypes.string.isRequired,
  titleId: PropTypes.string,
  titleTestId: PropTypes.string,
  description: PropTypes.string,
  descriptionTestId: PropTypes.string,
  children: PropTypes.node,
}
